import { ProjectAbstract } from '@/domain/project/entities/project.entity';
import { translate } from '@/ui/i18n';

export const getProjectState = (project: ProjectAbstract) => {
  if (project.startDate && project.endDate) {
    if (new Date() < new Date(project.startDate))
      return translate('Projects.coming');
    else if (new Date() < new Date(project.endDate))
      return translate('Projects.ongoing');
    else return translate('Projects.finished');
  } else return '';
};
